import { Outlet } from "react-router-dom";
import { useMe } from "../../hooks/useMe";
import { ForbiddenPage } from "../../routes/ForbiddenPage";
import { isAdminUser } from "../../lib/permissions";

type RequireRoleProps = {
  role: "admin" | "user";
};

export const RequireRole = ({ role }: RequireRoleProps) => {
  const { user } = useMe();
  if (role === "admin" && !isAdminUser(user)) {
    return <ForbiddenPage />;
  }

  return <Outlet />;
};
